import Backbone from 'backbone'
import template from './drawer-layout.hbs'
import _ from 'lodash'
import $ from 'jquery'
import constants from 'scoreboard/components/constants'
import deviceType from 'scoreboard/components/device-type'
import mobile from 'scoreboard/components/mobile'
import layoutManager from 'scoreboard/components/layout-manager'
import scrollContainer from 'scoreboard/components/scroll-container'

var DrawerLayout = Backbone.View.extend({
	// The percentage of whatever container should be filled by the drawer when it is deployed.
	DRAWER_HEIGHT_ADJUSTMENT: .75,

	className: 'display-layout drawer-layout table-hack',

	events: {
		'click .handle': 'toggleDrawerOpen'
	},

	/**
	 * Displays a "drawer" at the bottom of the screen that can be expanded over
	 * the main content. Used for notes on scorecard/initiative overview and
	 * dataset filters on dashboards
	 *
	 * @param {Object} options
	 *
	 * @param {boolean} [options.showDrawer=true] whether the drawer should initially
	 * be visible (not just open/closed); can be show/hidden later using toggleVisibility()
	 */
	initialize: function({ showDrawer = true }) {
		this.showDrawer = showDrawer
		this.on('resize', () => this.resize())
		_.bindAll(this, 'resize')
	},

	render: function() {
		this.$el.empty().append(template({
			showDrawer: this.showDrawer
		}))
		this.handle = this.$('.drawer-container .handle')
		this.drawerContainer = this.$('.drawer-container')
		this.drawerContentContainer = this.$('.drawer-content-container')
		this.renderDrawerContent(this.$('.drawer-content').empty())
		return this
	},

	/**
	 * Adds the given header Backbone.View in the appropriate location and renders it
	 */
	setHeader: function (headerView) {
		this.$el.prepend(headerView.el)
		headerView.render()
	},

	/**
	 * Returns the container DOM node for the main non-drawer content (ie the
	 * dashboard canvas or the scorecard overview)
	 *
	 * @return {jQuery}
	 */
	mainContentContainer: function () {
		return this.$('.scroll-container')
	},

	/**
	 * Renders the contents of the drawer (notes, filters, etc). Should be
	 * implemented by subclasses.
	 *
	 * @abstract
	 *
	 * @param container {jQuery} DOM node that the content should be rendered in
	 */
	renderDrawerContent: function (container) {},

	/**
	 * Returns the number of items in the drawer (notes, filters, etc). Should be
	 * implemented by subclasses.
	 *
	 * @abstract
	 */
	count: function () {},

	/**
	 * Returns the number of drawer items currently out of view due to scroll.
	 */
	 _getHiddenItems() {
		this.$('.drawer-container').removeClass('is-not-displayed')
		// figure out how many items are hidden
		var visibleItems = _.findIndex(this.$('.drawer-item'), item => {
			return !this._isScrolledIntoView(item)
		})

		visibleItems = visibleItems < 0 ? this.count() : visibleItems // handle no hidden items
		return this.count() - visibleItems
	},

	// The mobile layout and our small/medium displays show a preview of the first couple of items.
	// These layouts make you scroll to the bottom because they aren't fixed to the bottom of the screen.
	// Therefore, we need to check if they are in view as we scroll to know if the "Show more" button needs
	// appended since the isScrolledIntoView() function won't return true until it is in view. Issue #24118
	_mobileResize() {
		// If the drawer should keep its standard layout of being fixed to the bottom of the screen
		// regardless of screensize (i.e. dataset-filter-layouts), attach a class called `.standard-layout`
		let standardLayout = this.$el.hasClass('standard-layout')
		if (mobile.isMobileWidth() && !standardLayout) {
			if (!this.mobileScroll) {
				this.$el.on('scroll', this.resize)
				this.mobileScroll = true
			}
		} else if (layoutManager.inLayout(['.display-medium','.display-small']) && !standardLayout) {
			if (!this.mobileScroll) {
				this.$('.display-container').on('scroll', this.resize)
				this.mobileScroll = true
			}
		} else {
			this.$el.off('scroll', this.resize)
			this.$('.display-container').off('scroll', this.resize)
			this.mobileScroll = false
		}
	},

	// If the drawer is open, return true, else false
	_isOpen() {
		return this.$el.hasClass('is-drawer-expanded')
	},

	_setDrawerHeight(height) {
		this.$('.sizer').css('padding-top', height)
	},

	// Returns the number of items in the drawer which are visible and not scrolled
	// out of view.
	_getVisibleItems() {},

	// update the toggler that displays custom text or "Close"
	resize: function() {
		this._mobileResize()
		let drawerOverflow = this.drawerContentContainer.height() > constants.DRAWER_ALWAYS_OPEN_HEIGHT

		if (this._shouldDrawerStayOpen()) {
			this.$el.addClass('is-always-open')
			this.handle.toggleClass('is-not-displayed', !drawerOverflow)

			if (this._isOpen()) {
				this._setDrawerHeight(this._getMaxDrawerHeight())
			} else {
				this._setDrawerHeight(constants.DRAWER_ALWAYS_OPEN_HEIGHT)
			}

			this._updateHandleText()
			return
		} else {
			this.$el.removeClass('is-always-open')
		}

		// Toggle whether we should be showing the handle, and if we should be,
		// update it's text.
		if (this._isOpen()) {
			this.handle.removeClass('is-not-displayed')
			this._updateHandleText()
		} else {
			this._setDrawerHeight(constants.DRAWER_CLOSED_HEIGHT)
			this.handle.removeClass('is-not-displayed')
			this._updateHandleText()
		}

		// If the drawer isn't open, there's nothing to do because all the items
		// are out of view.
		if (!this._isOpen()) {
			return
		}

		// For small displays, if we know there are hidden items, we can stop calling resize on scroll.
		if (this._getHiddenItems() > 0) {
			this.$el.off('scroll', this.resize)
			this.$('.display-container').off('scroll', this.resize)
		}
	},

	/**
	 * Sets whether the drawer is visible (not just open/closed)
	 */
	toggleVisibility(visible) {
		this.$('.drawer-row').toggleClass('is-not-displayed', !visible)
		this.$el.toggleClass('is-hiding-drawer', !visible)
	},

	/**
	 * Calculates the item number and text which should be associated with this particular
	 * handle and then updates it.
	 */
	_updateHandleText() {},

	_setHandleText(text) {
		this.$('.drawer-container .handle .text').text(text)
	},

	/**
	 * Calculates and returns the maximum height the drawer should be taking up when it's open.
	 * 75% of the available space works well, if not this should be overridden.
	 */
	_getMaxDrawerHeight() {
		let available = this.$('.display-pane-body').height() + this.$('.drawer-row').height()
		return available * this.DRAWER_HEIGHT_ADJUSTMENT
	},

	/**
	 * @returns True if the drawer has at least enough space to stay at the .is-always-open height.
	 */
	_shouldDrawerStayOpen() {

		if (this._isOpen()) {
			return true
		}

		let originalHeight = this.$('.drawer-row').height()
		this._setDrawerHeight(constants.DRAWER_ALWAYS_OPEN_HEIGHT)
		let sc = scrollContainer(this.el)[0]
		let fits = sc.scrollHeight <= sc.clientHeight
		this._setDrawerHeight(originalHeight)
		return fits
	},

	/**
	 * Toggles the open/closed state of the drawer
	 */
	toggleDrawerOpen: function() {
		// Close the drawer
		if (this._isOpen()) {
			this.$el.removeClass('is-drawer-expanded')
			let stayOpen = this._shouldDrawerStayOpen()

			// Bumping this out to the next tick because changing the height this many times in
			// quick succession ignores the transition effect.
			setTimeout(() => {
				// Append .is-drawer-collapsing to activate the css transition effect
				this.$el.addClass('is-drawer-collapsing')

				// we don't know how many items will fit so we have to wait to
				// display the "show <items> (x)" text
				this.$('.drawer-row .table-hack-cell .sizer').one('transitionend', () => {
					this.$el.removeClass('is-drawer-collapsing')
					this.handle.removeClass('is-not-displayed')
					this._updateHandleText()
					this.trigger('toggleDrawer:collapse')
				})

				if (stayOpen) {
					this._setDrawerHeight(constants.DRAWER_ALWAYS_OPEN_HEIGHT)
				} else {
					this._setDrawerHeight(constants.DRAWER_CLOSED_HEIGHT)
				}
			}, deviceType.firefox ? 100 : 0) // #37249
		// Open the drawer
		} else {
			this.$el.addClass('is-drawer-expanded')
			this._setDrawerHeight(this._getMaxDrawerHeight())
			this.drawerContentContainer.scrollTop(0)
			this.$('.drawer-row .table-hack-cell').one('transitionend', () => {
				this.resize()
				this.trigger('toggleDrawer:expand')
			})
		}
	},

	// copied from http://stackoverflow.com/a/488073/393274
	_isScrolledIntoView(elem) {
		var $elem = $(elem)
		var $window = $(window)

		var docViewTop = $window.scrollTop()
		var docViewBottom = docViewTop + $window.height()

		var elemTop = $elem.offset().top
		var elemBottom = elemTop + $elem.height()

		return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop))
	}
})

export default DrawerLayout

DrawerLayout.__filename__ = 'components/drawer-layout.js'
